import { Button, Card, Col, DatePicker, Divider, Form, Row } from "antd";
import axios from "axios";
import React, { useCallback, useState } from "react";
import { authenticateToken } from "../../utils/auth";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const ProductOrderList = () => {
  const [form] = Form.useForm();
  const [range, setRange] = useState({
    from: null,
    to: null,
  });

  const [downloadData, setDownloadData] = useState({
    loading: false,
    data: null,
  });

  const getDownloadData = useCallback(async () => {
    console.log("From:", range);
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setDownloadData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/order/download/product-order?` +
          (from ? `from=${from}` : ``) +
          (to ? `&to=${to}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setDownloadData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setDownloadData({ loading: false, data: null });
        console.error("Promo: Error", err);
      });
  }, [range]);

  const simpleFileDownload = () => {
    window.location.href = downloadData?.data?.url;
  };

  const reseAllFieldData = () => {
    form.resetFields();
    setRange({
      from: null,
      to: null,
    });
  };

  return (
    <React.Fragment>
      <Row align="middle" justify="center">
        <Col span={8}>
          <Card title="Download Order Report">
            <Form.Item name="range">
              <RangePicker
                onChange={(f) => {
                  console.log("momnet", moment.utc(f[0])?.toISOString());
                  setRange({ from: f?.[0], to: f?.[1] });
                }}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [
                    moment("00:00:00", "HH:mm:ss"),
                    moment("23:59:59", "HH:mm:ss"),
                  ],
                }}
                inputReadOnly
                allowClear
                onOk={() => getDownloadData()}
              />
            </Form.Item>

            {downloadData?.data?.url && (
              <>
                {" "}
                <Divider />
                <Button
                  type="primary"
                  shape="round"
                  icon={<DownloadOutlined />}
                  size="large"
                  onClick={simpleFileDownload}
                >
                  Download
                </Button>{" "}
                <Button
                  danger
                  size="large"
                  type="dashed"
                  shape="round"
                  onClick={() => reseAllFieldData}
                  className="mx-2"
                >
                  Reset
                </Button>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ProductOrderList;
